import React from 'react';
import { Link } from 'react-router-dom';

export const renderMappingButton = (data, config, setMappingContent) => {
  const { displayValue, mappingItems, columVisibilityModelKey, tabSegment, name, viewSegment = '/summary' } = config;
  
  return (
    <button
      className="tab-links"
      onClick={() => setMappingContent(() => ({
        name,
        isActive: true,
        tabSegment,
        viewSegment, // Usar el viewSegment del config, por defecto '/summary'
        mappingItems,
        columVisibilityModelKey,
      }))}
    >
      {displayValue}{' '}
    </button>
  );
};

export const renderNavigationLink = (value, url) => {
  return (
    <Link className="tab-links" to={url}>
      {value}{' '}
    </Link>
  );
};